import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { ICO_ABI } from "../../Contract/ICO_ABI";
import { ICO_CONTRACT_ADDRESS } from "../../utils/constant";
import { useWriteContract, usePublicClient } from "wagmi";
import { useAppKitAccount } from "@reown/appkit/react";
import Loader from "../Loader/Loader";
import { handleError } from "../../utils/helper";
import { config } from "../../config";
import { readContract } from "@wagmi/core";

const SetICOTimeModal = ({ show, handleClose }) => {
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [loading, setLoading] = useState(false);
  const { writeContractAsync } = useWriteContract();
  const { address } = useAppKitAccount();
  const publicClient = usePublicClient();

  const handleSave = async () => {
    if (!startTime || !endTime) {
      toast.error("Both start and end times are required");
      return;
    }

    const start = Math.floor(new Date(startTime).getTime() / 1000);
    const end = Math.floor(new Date(endTime).getTime() / 1000);

    if (end <= start) {
      toast.error("End time must be after start time");
      return;
    }

    // 2️⃣ Parse the dates safely
    const startDate = new Date(startTime);
    const endDate = new Date(endTime);

    // 3️⃣ Check for invalid date objects
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      toast.error("Please enter valid date and time");
      return;
    }

    const now = new Date();

    // 4️⃣ Ensure both dates are not before current time
    if (startDate < now) {
      toast.error("Start date time cannot be in the past");
      return;
    }

    if (endDate < now) {
      toast.error("End date time cannot be in the past");
      return;
    }

    try {
      setLoading(true);

      const contractData = {
        abi: ICO_ABI,
        address: ICO_CONTRACT_ADDRESS,
        functionName: "setICOTime",
        args: [start, end],
      };

      await readContract(config, {
        ...contractData,
        account: address,
      });

      const tx = await writeContractAsync(contractData);

      const receipt = await publicClient.waitForTransactionReceipt({
        hash: tx,
      });
      if (receipt?.status === "success") {
        toast.success("ICO Time updated successfully");
        handleClose();
      }
    } catch (error) {
      console.log("ico set time error", error);
      const revertReason =
        error?.cause?.reason ||
        error?.shortMessage ||
        error?.message ||
        "Something went wrong";

      // Show in toast
      toast.error(revertReason);
      console.error("Contract revert reason:", revertReason);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Set ICO Time</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Start Time</Form.Label>
              <Form.Control
                type="datetime-local"
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>End Time</Form.Label>
              <Form.Control
                type="datetime-local"
                value={endTime}
                onChange={(e) => setEndTime(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SetICOTimeModal;
